import { Callout, Checkbox } from "@octopusdeploy/design-system-components";
import { Permission, PriorityMode } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import ExpandableFormSection from "../../../../../components/form/Sections/ExpandableFormSection";
import Summary from "../../../../../components/form/Sections/Summary";
interface PriorityOptionsProps {
    priority: PriorityMode;
    context: "deployment" | "runbook";
    onChange(value: boolean): void;
}
const PriorityOptions = (props: PriorityOptionsProps) => {
    const hasPermissionToChangePriority = isAllowed({ permission: [Permission.TaskPrioritize] });
    const getHelp = () => (props.context === "deployment" ? "Choose whether to deploy with priority" : "Choose whether to run with priority");
    const buildSummary = (priorityMode: PriorityMode) => (priorityMode === PriorityMode.On ? Summary.summary(`${props.context === "deployment" ? "Deploy" : "Run"} with priority`) : Summary.default("No priority"));
    return (<ExpandableFormSection title="Priority" errorKey="priority" help={getHelp()} summary={buildSummary(props.priority)}>
            <Callout title="Early Access" type={"warning"}>
                This feature is still in development and may be removed pending feedback. We'd love to hear <ExternalLink href={"priority-deployments-feedback"}> your feedback</ExternalLink> after using the Priority Tasks feature.
            </Callout>
            {!hasPermissionToChangePriority && (<Callout title="Missing permission" type={"information"}>
                    You require the TaskPrioritize permission to change the priority of this {props.context === "deployment" ? "deployment" : "runbook run"}.
                </Callout>)}
            <div>
                <Checkbox disabled={!hasPermissionToChangePriority} label="Priority" value={props.priority === PriorityMode.On} onChange={props.onChange}/>
            </div>
        </ExpandableFormSection>);
};
export default PriorityOptions;
